







































































































































import { Component, Vue } from 'vue-property-decorator';
import CreditNoteButton from './CreditNoteButton.vue';
import gql from 'graphql-tag';

const INVOICES_SEARCH = gql`
  query invoicesSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: InvoiceFilter
  ) {
    invoices(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ){
      id
      number
      issueDate
      dueDate
      payableAmount
      currencyCode
      note
      latestMailLog {
        id
        deliveryMethod
        deliveryStatus
      }
      customerParty {
        id
        name
        unofficialName
        phone
        mobile
        email
        partyIdentificationScheme
        partyIdentification
        city
        zip
        streetName
        additionalStreetName
        reference
        country {
          code
          name
        }
        countryCode
        vatRegulation
        foretaksRegisteredSince
      }
    }
  },
`;

@Component({
  components: {
    CreditNoteButton,
  },
})
export default class InvoiceList extends Vue {
  private INVOICES_SEARCH = INVOICES_SEARCH;
}
